import React from 'react';
import { BrowserRouter, Routes as DefaultRoutes, Route } from 'react-router-dom';

import SignIn from '../screens/SignIn';
import Home from '../screens/Home';
import SignOut from '../screens/SignOut';
import NoPage from '../screens/NoPage';
import ProtectedRoute from '../screens/ProtectedRoute';

const Routes = () =>{

  return (
      <BrowserRouter>
        <DefaultRoutes>
          <Route path='/'       element={<ProtectedRoute><Home/></ProtectedRoute>} exact/>
          <Route path='/login'  element={<SignIn/>}/>
          <Route path='/logout' element={<ProtectedRoute><SignOut/></ProtectedRoute>}/>
          <Route path='*'       element={<NoPage/>}/>
        </DefaultRoutes>
      </BrowserRouter>
  );
};

export default Routes;
